import { render, staticRenderFns } from "./ContactNoteCard.vue?vue&type=template&id=8903fdb4&"
import script from "./ContactNoteCard.vue?vue&type=script&lang=ts&"
export * from "./ContactNoteCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports